var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudBadConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5399 19H6.23077C2.79554 19 0 16.2052 0 12.7692C0 10.9208 0.830769 9.172 2.24792 7.98954C2.13438 7.62815 2.07692 7.25777 2.07692 6.88462C2.07692 4.78485 3.78485 3.07692 5.88462 3.07692C6.35538 3.07692 6.82615 3.16969 7.27269 3.349C8.58877 1.84946 10.4497 1 12.4615 1C16.2789 1 19.3846 4.10569 19.3846 7.92308C19.3846 8.12038 19.3742 8.32462 19.3535 8.53785C21.0704 9.53962 22.1538 11.3908 22.1538 13.3861C22.1538 16.4814 19.6352 19 16.5399 19ZM5.88462 4.46154C4.54846 4.46154 3.46154 5.54846 3.46154 6.88462C3.46154 7.23423 3.54392 7.58454 3.70662 7.92377C3.85338 8.22977 3.75646 8.59738 3.47746 8.79054C2.16692 9.703 1.38462 11.1908 1.38462 12.7692C1.38462 15.4408 3.55846 17.6154 6.23077 17.6154H16.5399C18.8723 17.6154 20.7692 15.7185 20.7692 13.3861C20.7692 11.7557 19.8042 10.2513 18.3115 9.55415C18.0312 9.42331 17.8712 9.12215 17.9211 8.81685C17.9744 8.48592 18 8.19377 18 7.92308C18 4.86931 15.5153 2.38462 12.4615 2.38462C10.6982 2.38462 9.07892 3.20154 8.019 4.62631C7.80715 4.91085 7.41531 4.98908 7.11069 4.80908C6.72231 4.57854 6.30969 4.46154 5.88462 4.46154Z",
    fill: "#E67670"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.248407,
    y: 1.23828,
    width: 1.90096,
    height: 28.7726,
    rx: 0.950481,
    transform: "rotate(-45 0.248407 1.23828)",
    fill: "#E67670"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.248407,
    y: 1.23828,
    width: 1.90096,
    height: 28.7726,
    rx: 0.950481,
    transform: "rotate(-45 0.248407 1.23828)",
    stroke: "#989CA3",
    strokeWidth: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.248407,
    y: 1.23828,
    width: 1.90096,
    height: 28.7726,
    rx: 0.950481,
    transform: "rotate(-45 0.248407 1.23828)",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBadConnection);
export default __webpack_public_path__ + "static/media/cloud-bad-connection.f918897634a6fc735317379e24df3e94.svg";
export { ForwardRef as ReactComponent };